import * as React from 'react';
import Modal from 'react-modal';
import './BusyModal.scss';
import {cStylesApp} from '../../CustomModalStyles';

interface BusyModalProps {
  message?: string;
}

const BusyModal: React.FC<BusyModalProps> = (props: any) => {
  Modal.setAppElement('body');
  return (
    <Modal isOpen={props.message !== undefined && props.message !== ''}
      style={cStylesApp}>
      <div className="busy-modal">
        {props.message ? <h3>{props.message}</h3> : null}
        <svg className="loader-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" />
        </svg>
      </div>
    </Modal>
  );
};
export default BusyModal;

export const LoadingSpinner: React.FC = () => {
    return (
        <div className="busy-modal">
            <svg className="loader-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" />
            </svg>
        </div>
    )
}
